let disableLogo = false;
window.addEventListener("resize", calculateMarginNavbar);


function calculateMarginNavbar() {
    let headerTopHeight = $("nav").height();

    let nav_successor = document.getElementsByClassName('margin-top-navbar');

    for (let i = 0; i < nav_successor.length; i++) {
        $(nav_successor[i]).css("margin-top", headerTopHeight);
    }
}

calculateMarginNavbar();

// Register addEventListeners to colorize navbar links

let target_nav_1 = document.getElementById('leistungen_dropdown');
let target_nav_2 = document.getElementById('service_dropdown');
let config = {attributeFilter: ["class"]};


let observer = new MutationObserver(function (mutation) {
    mutation.forEach(function (mutation) {
        manageDropdownStyling(mutation.target);
    })
});

observer.observe(target_nav_1, config);
observer.observe(target_nav_2, config);

let shown;

function manageDropdownStyling(target) {
    const $target_id = '#' + $(target).attr('id');
    const header_logo = $("#header_logo");


    if (target) {
        shown = target.classList.contains('show');

        if (shown) {
            $($target_id).css('background-color', '#fff');
            $($target_id + " a").css('color', '#000');

            if (window.matchMedia("screen and (min-width: 992x)").matches) {
                header_logo.fadeOut();
                disableLogo = true;
            }
        } else {
            $($target_id).css('background-color', 'inherit');
            $($target_id + " a").css('color', '');


            if (window.matchMedia("screen and (min-width: 992px)").matches) {
                fadeInLogo(header_logo);
            }
        }
    }
}

function fadeInLogo($logo){
    // Wait for let shown to be reset if a different nav-link has been clicked
    setTimeout(() => {
        if(!shown) {
            $logo.fadeIn();
            disableLogo = false;
        }
    }, 100);
}

module.exports = {
    getDisableLogo: function () {
        return disableLogo;
    }
};

/*
// OLD JS CODE TO CHANGE NAVBARS POSITION FROM FIXED TO RELATIVE AND HIDE CONTENT TO ENABLE SCROLLING

let but = document.getElementById('leistungenExpand');

but.addEventListener("click", wait);


function wait() {
    setTimeout(makeScrollable,125);
}


function heightMismatch() {
    let device_height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    //let header_height = document.querySelector('.header-fixed')[0].scrollHeight;
    let header_height = $(".header-fixed").height();

    console.log("header-height: " + header_height);
    console.log("device-height: " + device_height);



    console.log(header_height > device_height);
    return header_height > device_height;
}


function makeScrollable() {
    if(heightMismatch()){
        // hide Elements
        $("main").hide();
        $("footer").hide();
        $(".header-fixed").css('position','relative');

    }
    else{
        // make Elements visible
        $("main").show();
        $("footer").show();
        $(".header-fixed").css('position','fixed');

    }
}

 */